import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from '@mui/material';

import { AlertComponent } from 'components/_basic/AlertComponent';

export const BalanceAlert: FC = () => {
  const { t } = useTranslation();

  return (
    <AlertComponent
      severity="error"
      message={
        <Typography variant="subtitle2">
          <Typography variant="subtitle2" component="span" fontWeight={700}>
            {t('financialPlan.openingBalanceSheets.totalAssets')}
          </Typography>
          &nbsp;
          {t('financialPlan.openingBalanceSheets.sumOf')}
          &nbsp;
          <Typography variant="subtitle2" component="span" fontWeight={700}>
            {t('financialPlan.openingBalanceSheets.totalLiabilities')}
          </Typography>
          &nbsp;
          {t('and')}
          &nbsp;
          <Typography variant="subtitle2" component="span" fontWeight={700}>
            {t('financialPlan.openingBalanceSheets.totalEquity')}
          </Typography>
          {'.'}
          &nbsp;
          {t('financialPlan.openingBalanceSheets.checkCalculations')}
        </Typography>
      }
    />
  );
};
